type GtmPayload = Record<string, unknown>;

export const pushGtmEvent = (payload: GtmPayload) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};

export const trackGtmClick = (params: GtmPayload = {}) => {
  pushGtmEvent({
    event: 'click',
    ...params,
  });
};

export const trackGtmPageEnter = (params: {
  page_path: string;
  page_title: string;
  page_name: string;
}) => {
  pushGtmEvent({
    event: 'page_enter',
    event_category: 'navigation',
    event_action: 'page_enter',
    event_label: params.page_name,
    page_path: params.page_path,
    page_title: params.page_title,
  });
};
